import { Component } from '@angular/core';

@Component({
  selector: 'toasters',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  standalone: false,
})
export class ToasterComponent {}
